import { render } from "./GridPoPriceChanges.vue?vue&type=template&id=04bb2dc8&scoped=true"
import script from "./GridPoPriceChanges.vue?vue&type=script&lang=js"
export * from "./GridPoPriceChanges.vue?vue&type=script&lang=js"

import "./GridPoPriceChanges.vue?vue&type=style&index=0&id=04bb2dc8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04bb2dc8"]])

export default __exports__